import React, { useState, useRef, useEffect } from "react";
import "./CarveChat.css";
import { MicrophoneIcon, PaperPlaneIcon } from "@phosphor-icons/react";

const ChatBox = () => {
  const [conversations, setConversations] = useState([]); // grouped
  const [input, setInput] = useState("");
  const chatEndRef = useRef(null);

  // Auto-scroll
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversations]);

  // Highlight keywords
  const highlightKeywords = (text, keywords) => {
    let highlighted = text;
    keywords.forEach((keyword) => {
      const regex = new RegExp(`(${keyword})`, "gi");
      highlighted = highlighted.replace(
        regex,
        '<span className="highlight">$1</span>'
      );
    });
    return highlighted;
  };

  // Send handler
  const handleSendMessage = () => {
    if (!input.trim()) return;
    const userText = input.trim();

    // Add conversation with loading system message
    const newConversation = {
      id: Date.now(),
      user: `<div class="message-content">${userText}</div>`,
      system: `<div class="message-content"><span className="highlight">...</span></div>`,
      loading: true,
    };

    setConversations((prev) => [...prev, newConversation]);
    setInput("");

    // Keywords and dummy response
    const keywordsToHighlight = ["creating", "Eywa"];
    const dummyResponse = `Your query about [<strong>${userText}</strong>] is taken.
      <div class="shimmer">The Eywa's response.</div>`;

    // Update after delay
    setTimeout(() => {
      setConversations((prev) =>
        prev.map((c) =>
          c.id === newConversation.id
            ? {
              ...c,
              system: `<div className="message-content">${highlightKeywords(
                dummyResponse,
                keywordsToHighlight
              )}</div>`,
              loading: false,
            }
            : c
        )
      );
    }, 1000);
  };

  // Enter = send, Shift+Enter = new line
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="chat-outer-wrapper">
      <div className="carve-chat">
        <div className="chat-messages" id="chatMessages">
          {conversations.map((conv) => (
            <div key={conv.id} className="chat-turn">
              <div
                className="chat-message user-message"
                dangerouslySetInnerHTML={{ __html: conv.user }}
              />
              <div
                className="chat-message system-message"
                dangerouslySetInnerHTML={{ __html: conv.system }}
              />
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>

        <div className="chat-wrapper carve-chat-wrapper">
          <div className="carve-textarea-wrapper">
            <textarea
              id="carveTextarea"
              className="carve-textarea"
              rows="4"
              placeholder="Ask design, The 'Eywa' is ready to give!"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <div className="carve-text-action">
              <div className="carve-group">
                <MicrophoneIcon fill="white" size={24} />
                <PaperPlaneIcon fill="white" size={24} onClick={handleSendMessage} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ChatBox;
